import React from 'react';
import ChartViewComponent from '../components/chartView';
import soapRequest from '../helpers/soapRequest';
import domtoimage from 'dom-to-image-more';
import fileDownload from "js-file-download";
import xmlParserFiltersData from '../helpers/xmlParserFiltersData';
import xmlParserChartsData from '../helpers/xmlParserChartsData';
import CircularProgress from '@mui/material/CircularProgress';
import xmlParserChartConfig from '../helpers/xmlParserChartConfig';
import JSZip from 'jszip';
import { CsvBuilder } from 'filefy';


class ChartView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      timeout: props.timeout,
      token: sessionStorage.getItem('userToken'),
      filters: [],
      filtersMessage: [],
      chartData: null,
      chartConfig: [],
      chartConfigResult: {},
      disabled: true,
      chartTitle: "Sin datos para graficar",
      expanded: "chart-configuration",
      chartConfigMessage: "",
      requiredFilters: [],
      disabledCreateChart: true,
      showChart: false,
      showTable: false,
      numberOfCharts: null,
      selectedSlide: 0,
      exportAllButtonText: "Exportar todos los gráficos",
      exportButtonText: "Exportar el gráfico actual",
      exportTableButtonText: "Exportar a Excel",
      tableTitle: null,
      tableHeader: null,
      tableRows: null
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.handleCreateChart = this.handleCreateChart.bind(this);
    this.handleExportChart = this.handleExportChart.bind(this);
    this.updateFiltersMessage = this.updateFiltersMessage.bind(this);
    this.setChartConfiguration = this.setChartConfiguration.bind(this);
    this.handleSaveConfiguration = this.handleSaveConfiguration.bind(this);
    this.handleChangeAccordion = this.handleChangeAccordion.bind(this);
    this.setRequiredFilters = this.setRequiredFilters.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.updateTheNumberOfGeneratedCharts = this.updateTheNumberOfGeneratedCharts.bind(this);
    this.handleExportAllCharts = this.handleExportAllCharts.bind(this);
    this.updateSelectedSlide = this.updateSelectedSlide.bind(this);
    this.handleCreateTable = this.handleCreateTable.bind(this);
    this.updateTableData = this.updateTableData.bind(this);
    this.handleExportTable = this.handleExportTable.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    const { token, timeout } = this.state;
    var messageArray= [];
    messageArray.push(
      '<message>',
      '<token>',
      token,
      '</token>',
      '</message>'
    )
    var message = messageArray.join("");
    soapRequest('getChartsList', timeout, message).then((result) => {
      const chartConfig = xmlParserChartConfig(result);
      this.setState({ chartConfig: chartConfig })
    })
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  /**
     * Obtiene y actualiza las dimensiones de la ventana del navegador.
    */
  updateWindowDimensions() {
    if((this.state.width != window.innerWidth) || (this.state.height != window.screen.availHeight)){
      this.setState({
        width: window.innerWidth, 
        //height: window.innerHeight
        height: window.screen.availHeight
      });
    }
  }

  /**
    * Asigna y/o actualiza los datos seleccionados en la configuración del gráfico.
    * @param {JSON} data - Datos seleccionados en configuración del gráfico.
   */
  setChartConfiguration(data) {
    const { chartConfigResult, chartConfig } = this.state;
    var key = Object.keys(data)[0];
    var value = data[key];
    chartConfigResult[key] = value;
    this.setState({ chartConfigResult: chartConfigResult })
    var totalParameters = null;
    if (chartConfigResult.category !== null) {

      chartConfig.map((category) => {
        if (category.id === chartConfigResult.category) {
          totalParameters = category.parameters.length;
        }
      })

    }
    var disabled = Object.keys(chartConfigResult.options).length === totalParameters ? false : true;
    this.setState({ disabled: disabled })
  }

  /**
     * Realiza solicitud SOAP para obtener los filtros asociados a la configuración del gráfico seleccionada.
    */
  handleSaveConfiguration(smCheck) {
    const { token, timeout, chartConfigResult, chartConfig } = this.state;
    var parametersMessage = "";
    var parametersMessageArray=[];
    var parametersArray = [];
    var chartConfigMessage = "";
    var chartConfigMessageArray = [];
    var titleArray = [];
    
    const parameters = chartConfig[chartConfigResult.category - 1].parameters;
    Object.keys(chartConfigResult.options).forEach(function (key) {
      var value = chartConfigResult.options[key];
      //Arreglo con mensaje para cada parámetro
      parametersArray.push(
        '<parameterid reference="',
        key,
        '">',
        value,
        '</parameterid>'
      );
      if (parameters.length !== 0) {
        parameters.map((parameter) => {
          parameter.options.map((option) => {
            if (option.id === value)
              titleArray.push(option.name)
          })
        })
      }
    });
    parametersMessage = parametersArray.join("");
    //Arreglo con mensaje para conjunto de parametros
    parametersMessageArray.push(
      '<parameters>',
      parametersMessage,
      '</parameters>'
    );
    parametersMessage = parametersMessageArray.join("");
    var chartConfigMessageArray=[];

    //Arreglo con mensaje completo con configuración para gráficos
    chartConfigMessageArray.push(
      '<message>',
      '<token>',
      token,
      '</token>',
      '<chartcategoryid>',
      chartConfigResult.category,
      '</chartcategoryid>',
      parametersMessage,
      '</message>'
    );
    
    chartConfigMessage = chartConfigMessageArray.join("");
    var filters = [];
    var requiredFilters = [];
    soapRequest('getFilterList', timeout, chartConfigMessage).then((result) => {
      filters = xmlParserFiltersData(result);
      this.setState({ filters: filters })
      filters.forEach((filter) => {
        if (filter.required) {
          requiredFilters.push(filter.filterId);
        }
        if(filter.subFilters !== undefined){
          filter.subFilters.forEach((subFilter) => {
            if (subFilter.required) {
              requiredFilters.push(subFilter.filterId);
            }
          });
        }
      });
      this.setState({requiredFilters:requiredFilters});
    });
    var chartTitle = titleArray.length !== 0 ? titleArray[1] + " v/s " + titleArray[0] : "# de solicitudes al software v/s tiempo y lugar";
    var expand;
    if(smCheck){
      expand = 'filter-view';
    } else {
      expand = 'chart-view';
    }
    this.setState({
      chartTitle: chartTitle,
      expanded: expand,
      chartConfigMessage: chartConfigMessage,
      chartData: null,
      disabledCreateChart: true,
      filtersMessage: [],
    });
  }

  /**
    * Comprime y descomprime paneles expansibles (panel "Datos para generar gráficos" y panel "Gráficos").
    * @param {Event} e - Evento que se  desencadena al hacer clic sobre un panel de expansión.
  */
   handleChangeAccordion(e) {
    const { expanded } = this.state;
    if (expanded === e.currentTarget.id) {
      this.setState({ expanded: '' });
    }
    else {
      this.setState({ expanded: e.currentTarget.id });
    }
  }

  /**
     * Función que asigna y/o actualiza los datos seleccionados en filtros de gráfico.
     * @param {JSON} data - Datos seleccionados en filtro.
    */
  updateFiltersMessage(data) {
    const { requiredFilters } = this.state;
    const id = data.id;
    const name = data.name;
    const parameters = data.parameters;
    const message = {
      id: id,
      name: name,
      parameters: parameters
    }

    /*refactored setState to use a Functional setState. why?
      the function updateFiltersMessage is called in quick succession when 
      loading the filters, this creates a race condition when updating the state
      causing occational problems.
      The functional setState solves this issue because of th following property:
      "Updates will be queued and later executed in the order they were called."
      source: https://medium.com/free-code-camp/functional-setstate-is-the-future-of-react-374f30401b6b
    */
    this.setState(prevState => {
      var filtersMessage = prevState.filtersMessage;
      //Busca filtros ya agregados y lo elimina del mensaje
      for (var i = 0; i < filtersMessage.length; i++) {
        if (filtersMessage[i].id === id) {
          filtersMessage.splice(i, 1);
          break;
        }
      }

      filtersMessage.push(message);
      var requiredCounter = 0;
      filtersMessage.map((filter) => {
        requiredFilters.map((requiredFilter) => {
          if (filter.id === requiredFilter && filter.parameters !== "")
            requiredCounter++;
        })
      });
      const disabledCreateChart = requiredFilters.length === requiredCounter && requiredFilters.length !== 0 ? false : true;
      return {
        filtersMessage: filtersMessage,
        disabledCreateChart: disabledCreateChart
      }
    });
  }

  setRequiredFilters(requiredFilters) {
    this.setState({ requiredFilters: requiredFilters });
  }

  /**
     * Función que solisita los datos para los graficos y realisa los ajustes requeridos para su despliege.
    */
  handleCreateChart(smCheck) {
    this.setState({
       chartData: null, 
       showTable: false,
       showChart: true
     })

    this.getDataFromServer();

    if (smCheck){
      this.setState({
        expanded: 'chart-view'
      });
    }
  }

  /**
     * Función que solisita los datos para las tablas y realisa los ajustes requeridos para su despliege.
    */
   handleCreateTable(smCheck) {
    this.setState({
       chartData: null, 
       showTable: true,
       showChart: false
     })

    this.getDataFromServer();
    if (smCheck){
      this.setState({
        expanded: 'chart-view'
      });
    }
  }

  /**
     * Función que realiza solicitud SOAP para obtener datos para gráficos enviando filtros seleccionados.
  */
  getDataFromServer(){
    const { filtersMessage, chartConfigMessage, timeout } = this.state;
    var filtersMessageXML = '';
    var filtersArray =[];
    var messageArray = [];
    var message = '';
    var filters ='';
    filtersMessage.map(filter => {

      filtersArray.push(
        '<filter>',
        '<id>',
        filter.id,
        '</id>',
        '<name>',
        filter.name,
        '</name>',
        '<parameters>',
        filter.parameters,
        '</parameters>',
        '</filter>'
      )
    })
    filters = filtersArray.join('');
    messageArray.push(
      '<message>',
      chartConfigMessage,
      '<filters>',
      filters,
      '</filters>',
      '</message>'
    )
    message = messageArray.join('');
    soapRequest('getChartData', timeout, message).then((result) => {
      const chartData = xmlParserChartsData(result);
      this.setState({ chartData: chartData });
    })
  }

  /**
   * Función que permite informar a este componente la cantidad de graficos generados con el proposito de poder exportalos de forma correcta.
  */
  updateTheNumberOfGeneratedCharts(newNumberOfCharts){
    this.setState({
      numberOfCharts: newNumberOfCharts
    });
  }

  /**
   * Función que permite informar a este componente cual es el grafico que el usuario esta viendo.
  */
   updateSelectedSlide(value){
    this.setState({
      selectedSlide: value
    });
  }

  /**
     * Función que permite descargar el gráfico generado como imagen en formato png.
    */
  handleExportAllCharts() {

    var scale = 2;
    var promises = [];
    var i;
    var domNode;
    var promise;
    //change button text
    this.setState({
      exportAllButtonText: 'Exportando, por favor espere'
    }, () => {
      setTimeout( () => {
        // generate all image blobs
        for(i=0; i < this.state.numberOfCharts; i++){
          domNode = document.getElementById('chart-image-'+i);
          promise = domtoimage.toBlob(domNode, {
            width: domNode.clientWidth * scale,
            height: domNode.clientHeight * scale,
            bgcolor: '#ffffff',
            style: {
              transform: 'scale(' + scale + ')',
              transformOrigin: 'top left'
            }
          })
          promises.push(promise);
        }
        //compress all images into a single zip
        var zip = new JSZip();
        Promise.all(promises).then((blobValues) => {
          for(i=0; i < this.state.numberOfCharts; i++){
            //put all blobs in a zip;
            zip.file('class-chart-'+ (i+1) +'.png', blobValues[i]);
          }
          zip.generateAsync({type:"blob"}).then( (content) => {
            fileDownload(content, 'generated-class-charts.zip');
            this.setState({
              exportAllButtonText: "Exportar todos los gráficos"
            });
          });
        });
      }, 1 );

    });
      
  }

  /**
   * Función que permite descargar el gráfico generado como imagen en formato png.
  */
  handleExportChart() {
  var domNode;
  var scale = 2;
  this.setState({
    exportButtonText: 'Exportando, por favor espere'
  }, () => {
    setTimeout( () => {
      domNode = document.getElementById('chart-image-'+this.state.selectedSlide);
      domtoimage.toBlob(domNode, {
        width: domNode.clientWidth * scale,
        height: domNode.clientHeight * scale,
        bgcolor: '#ffffff',
        style: {
          transform: 'scale(' + scale + ')',
          transformOrigin: 'top left'
        }
      })
        .then((blob) => {
          fileDownload(blob, 'class-chart.png');
          this.setState({
            exportButtonText: "Exportar el gráfico actual"
          });
        });
      }, 1);
  });

  
  }
  
  /**
   * Función que permite informar a este componente cuales son los datos desplegados en la tabla, para poder exportarlos.
  */
   updateTableData(title, header,rows){
    this.setState({
      tableTitle: title,
      tableHeader: header,
      tableRows: rows
    });
  }

  /**
   * Función que permite descargar las tablas generadas como un archivo CSV.
  */
  handleExportTable() {
    var csvBuilder = new CsvBuilder("class-table.csv")
      .setDelimeter(';')
      .setColumns(this.state.tableTitle)
      .addRow(this.state.tableHeader)
      .addRows(this.state.tableRows)
      .exportFile();

  }


  /**
   * Función que permite volver a la configuracion del gráfico desde el panel de gráficos a través del botón "Volver".
  */
  handleBack() {
    this.setState({ expanded: 'chart-configuration' });
  }

  render() {
    const {
      height, width, filters, chartData, chartConfig, chartConfigResult, disabled, chartTitle, expanded, disabledCreateChart, showChart, showTable, exportAllButtonText, exportButtonText, exportTableButtonText
    } = this.state;
    return (
      chartConfig.length === 0 ?
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100vh' }}>
          <CircularProgress
            size='50px'
            color="secondary"
          />
        </div>
        :
        <ChartViewComponent
          handleCreateChart={this.handleCreateChart}
          handleCreateTable={this.handleCreateTable}
          handleExportChart={this.handleExportChart}
          updateFiltersMessage={this.updateFiltersMessage}
          height={height}
          width={width}
          filters={filters}
          chartConfig={chartConfig}
          chartData={chartData}
          setChartConfiguration={this.setChartConfiguration}
          chartConfigResult={chartConfigResult}
          disabled={disabled}
          handleSaveConfiguration={this.handleSaveConfiguration}
          handleChangeAccordion={this.handleChangeAccordion}
          chartTitle={chartTitle}
          expanded={expanded}
          setRequiredFilters={this.setRequiredFilters}
          disabledCreateChart={disabledCreateChart}
          handleBack={this.handleBack}
          showChart={showChart}
          showTable={showTable}
          updateTheNumberOfGeneratedCharts={this.updateTheNumberOfGeneratedCharts}
          handleExportAllCharts={this.handleExportAllCharts}
          updateSelectedSlide={this.updateSelectedSlide}
          exportAllButtonText={exportAllButtonText}
          exportButtonText={exportButtonText}
          exportTableButtonText={exportTableButtonText}
          updateTableData={this.updateTableData}
          handleExportTable={this.handleExportTable}
        />
    )
  }
}

export default ChartView;